<template>
  <svg width="100" height="60" viewBox="0 0 100 60" fill="none" xmlns="http://www.w3.org/2000/svg">
    <!-- Stethoscope -->
    <path d="M30 15 C30 30, 50 30, 50 15" stroke="black" stroke-width="2" fill="transparent"/>
    <circle cx="30" cy="15" r="5" fill="black"/>
    <circle cx="50" cy="15" r="5" fill="black"/>

    <!-- Heart Animation -->
    <path d="M40 40 C 38 25, 20 30, 25 50 C30 65, 50 65, 55 50 C60 30, 42 25, 40 40"
          fill="red" stroke="black" stroke-width="2">
      <animateTransform attributeName="transform" type="scale" values="1;1.2;1" dur="1s" repeatCount="indefinite"/>
    </path>
  </svg>
</template>
